import MarketIndexSummaryCards from './MarketIndexSummaryCards';
import MarketLineChartView from './MarketLineChartView';
import useMarketData from './hooks/useMarketData';

function UsSectorsView() {
  const { dates, series, loading, error } = useMarketData('sectors');

  return (
    <>
      <div className="row market-summary-row mb-4">
        <MarketIndexSummaryCards series={series} loading={loading} skeletonCount={11} />
      </div>
      <div className="row mb-4">
        <MarketLineChartView
          chartId="us-sectors"
          title="US Sectors"
          series={series}
          dates={dates}
          loading={loading}
          error={error}
        />
      </div>
    </>
  );
}

export default UsSectorsView;
